<template>
  <div id="main-wrapper">
    <router-view />
    <loader />
  </div>
</template>

<script>
import Loader from "@/components/loader/Loader";

export default {
  name: "App",
  components: {
    Loader,
  },
};
</script>
 
<style>
  @import url('https://fonts.googleapis.com/css2?family=Material+Icons');
</style>
